import { createContext, useContext, useEffect, useRef } from "react";
import { getHostPrefix, getCookieByHost, getSocketURL, getSessionValue } from "../../../Common/Appcommon";import { useUsersContext } from './usersContext';
import { usePopupContext } from "../../../Common/context/popupContext";
let socketURL = getSocketURL();
const SOCKET_URL = window.location.origin.includes("localhost")
	? "http://localhost:5000"
	: socketURL;

const SSEContext = createContext();

const useSSEContext = () => useContext(SSEContext);

const SSEProvider = ({ children }) => {
	const usersContext = useUsersContext();
	const popupContext = usePopupContext();
	useEffect(() => {
		let prefix = getHostPrefix();
		const appid = getCookieByHost(prefix+'loginappid');
		const currentUserId= getSessionValue('loginuserid');
		let userKey = currentUserId + "_" + appid;
		// Create an EventSource instance connected to your SSE endpoint
		const eventSource = new EventSource(SOCKET_URL + `/events?userId=${userKey}`);

		// Event handler for incoming messages
		eventSource.onmessage = (event) => {
			const data = JSON.parse(event.data);
			let { entity } = data;
			if (entity === "refreshcontact") {
				if (usersContext !== undefined) {
					usersContext.refreshContacts(data);
				}
			} else if (entity === "incoming_call") {
				if (popupContext !== undefined) {
					popupContext.onIncomingCallMonitor(data);
				}
			}

		};

		// Event handler for errors
		eventSource.onerror = (error) => {
			console.error('SSE error:', error);
		};

		// Event handler for when the connection is opened
		eventSource.onopen = () => {
			console.log('SSE connection opened');
		};

		// Cleanup on component unmount
		return () => {
			eventSource.close();
		};
	}, []);

	return (
		<SSEContext.Provider >
			{children}
		</SSEContext.Provider>
	);
};

export { useSSEContext, SSEProvider };
